import React, { useCallback, useState } from "react";

import { Stack } from "@mui/material";
import { CashflowForecastSummary } from "components/Deal-insights/CashflowForecastSummary";
import { InsightsSectionCard } from "components/Deal-insights/InsightsSectionCard";
import { useDealForecast } from "components/Deal-insights/use-deal-forecast";
import { useNavigate } from "hooks";
import { LookThrough } from "pages/Look-through/LookThrough";
import { useAccountSelector, useDealIdSelector } from "store";

export const DealInsights: React.FC = () => {
  const dealId = useDealIdSelector();
  const navigate = useNavigate();
  const { show_cashflow } = useAccountSelector() || {};

  const forecast = useDealForecast({ enabled: !!show_cashflow });

  // An empty look-through has no full view to open, so hide its Show All.
  const [lookThroughEmpty, setLookThroughEmpty] = useState(false);
  const handleLookThroughState = useCallback(
    ({ isEmpty }: { loading: boolean; isEmpty: boolean }) => setLookThroughEmpty(isEmpty),
    []
  );

  const goLookThroughFull = () => dealId && navigate({ route: "dealInsightsLookThrough", params: { deal_id: dealId } });
  const goCashflowFull = () => dealId && navigate({ route: "dealInsightsCashflow", params: { deal_id: dealId } });

  const forecastShowAllHidden = forecast.isEmpty || forecast.error;

  return (
    <Stack sx={{ gap: "16px", p: "16px", flexGrow: 1, overflowY: "auto", backgroundColor: "#f6f8fc" }}>
      <InsightsSectionCard title="Look Through" onShowAll={goLookThroughFull} hideShowAll={lookThroughEmpty}>
        <LookThrough variant="summary" onSummaryStateChange={handleLookThroughState} onAddSuccess={goLookThroughFull} />
      </InsightsSectionCard>

      {show_cashflow && (
        <InsightsSectionCard
          title="Cashflow Forecast"
          onShowAll={goCashflowFull}
          showAllDisabled={forecast.loading}
          hideShowAll={forecastShowAllHidden}
        >
          <CashflowForecastSummary
            loading={forecast.loading}
            error={forecast.error}
            isEmpty={forecast.isEmpty}
            graph={forecast.graph}
            onRetry={forecast.refetch}
          />
        </InsightsSectionCard>
      )}
    </Stack>
  );
};
